export { mod as dayjsMod } from './dayjsExtensions.js';
export * from './plexSearchUtil.js';
export * as search from './searchUtil.js';
export * as seq from './seq.js';
import { capitalize, isArray, isNull, isNumber, isString } from 'lodash-es';
import isFunction from 'lodash-es/isFunction.js';
export function applyOrValueNoRest(f, arg) {
    return isFunction(f) ? f(arg) : f;
}
export function applyOrValue(f, arg, rest) {
    return isFunction(f) ? f(arg, ...rest) : f;
}
export function forProgramType(choices) {
    return (m) => {
        switch (m.type) {
            case 'content':
                if (choices.content) {
                    return applyOrValue(choices.content, m, []);
                }
                break;
            case 'custom':
                if (choices.custom) {
                    return applyOrValue(choices.custom, m, []);
                }
                break;
            case 'redirect':
                if (choices.redirect) {
                    return applyOrValue(choices.redirect, m, []);
                }
                break;
            case 'flex':
                if (choices.flex) {
                    return applyOrValue(choices.flex, m, []);
                }
                break;
            case 'filler':
                if (choices.filler) {
                    return applyOrValue(choices.filler, m, []);
                }
                break;
        }
        // If we made it this far try to do the default
        if (choices.default) {
            return applyOrValue(choices.default, m, []);
        }
        return null;
    };
}
export function forPlexMedia(choices) {
    return (m) => {
        switch (m.type) {
            case 'movie':
                if (choices.movie)
                    return applyOrValueNoRest(choices.movie, m);
                break;
            case 'show':
                if (choices.show)
                    return applyOrValueNoRest(choices.show, m);
                break;
            case 'season':
                if (choices.season)
                    return applyOrValueNoRest(choices.season, m);
                break;
            case 'episode':
                if (choices.episode)
                    return applyOrValueNoRest(choices.episode, m);
                break;
            case 'artist':
                if (choices.artist)
                    return applyOrValueNoRest(choices.artist, m);
                break;
            case 'album':
                if (choices.album)
                    return applyOrValueNoRest(choices.album, m);
                break;
            case 'track':
                if (choices.track)
                    return applyOrValueNoRest(choices.track, m);
                break;
            case 'collection':
                if (choices.collection)
                    return applyOrValueNoRest(choices.collection, m);
                break;
            case 'playlist':
                if (choices.playlist)
                    return applyOrValueNoRest(choices.playlist, m);
                break;
        }
        if (choices.default) {
            return applyOrValueNoRest(choices.default, m);
        }
        return null;
    };
}
export function nullToUndefined(x) {
    if (isNull(x)) {
        return undefined;
    }
    return x;
}
export const flushEventLoop = async () => {
    return new Promise((resolve) => {
        setTimeout(resolve, 0);
    });
};
const RomanNumeralMap = new Map([
    ['i', 1],
    ['v', 5],
    ['x', 10],
    ['l', 50],
    ['c', 100],
    ['d', 500],
    ['m', 1000],
]);
const RomanNumerRegex = /([MDCLXVI]+)/i;
export function isValidRomanNumeral(input) {
    return RomanNumerRegex.test(input);
}
export function romanNumeralToNumber(input) {
    if (input.length === 0) {
        return 0;
    }
    const lowercased = input.toLowerCase();
    let total = 0;
    let previousValue = Number.POSITIVE_INFINITY;
    for (let i = 0; i < lowercased.length; i++) {
        const current = RomanNumeralMap.get(input[i]);
        if (!current) {
            continue;
        }
        total += current > previousValue ? -previousValue : previousValue;
        previousValue = current;
    }
    return total + previousValue;
}
export function isNonEmptyString(s) {
    return isString(s) && s.length > 0;
}
export function emptyStringToNull(s) {
    return isNonEmptyString(s) ? s : null;
}
export function createTypeSearchField(type, op) {
    return {
        type: 'value',
        fieldSpec: {
            key: 'type',
            name: 'Type',
            op: op ?? '=',
            type: 'string',
            value: [type],
        },
    };
}
export function createParentFilterSearchField(parentId, op) {
    return {
        type: 'value',
        fieldSpec: {
            key: 'parent.id',
            name: '',
            op: op ?? '=',
            type: 'string',
            value: [parentId],
        },
    };
}
export function prettifySnakeCaseString(str) {
    return str
        .split('_')
        .map((x) => capitalize(x))
        .join(' ');
}
export function is2Tuple(value, pred) {
    if (!isArray(value))
        return false;
    if (value.length !== 2)
        return false;
    return pred(value[0]) && pred(value[1]);
}
export function isNumber2Tuple(value) {
    return is2Tuple(value, isNumber);
}
//# sourceMappingURL=index.js.map